module.exports = __webpack_public_path__ + "static/media/Picture3.0673d2a0.jpg";